export default __webpack_public_path__ + "be8136d6dea12e200f334c8db8ea7d1b.svg";